import React from "react";
import {
  Folder,
  Database,
  BarChart3,
  BrainCircuit,
  Shield,
  BookMarked,
  ArrowRight,
  Circle,
} from "lucide-react";
import About from "../About";

import data from "../../../../_data/about.json";

const iconMap = {
  Folder,
  Database,
  BarChart3,
  BrainCircuit,
  Shield,
  BookMarked,
  ArrowRight,
};

function getIcon(iconName) {
  return iconMap[iconName] || Circle;
}

export default function AboutDAS() {
  const aboutDAS = data?.aboutDAS;

  if (!aboutDAS) {
    return (
      <section className="about-das">
        <div className="about-das-empty">About D&AS data not found.</div>
      </section>
    );
  }

  return (
    <>
      <About />

      <section className="about-das">
        {/* Stats Section */}
        {aboutDAS.stats && (
          <div className="about-das-stats">
            {aboutDAS.stats.map((s, i) => (
              <div key={i} className="about-das-statItem">
                <div className="about-das-statValue">{s.value}</div>
                <div className="about-das-statLabel">{s.label}</div>
              </div>
            ))}
          </div>
        )}

        {/* Engagement Playbook Section */}
        {aboutDAS.playbook && (
          <div className="about-das-playbook">
            <div className="about-das-playbookHeader">
              <h2 className="about-das-playbookTitle">{aboutDAS.playbook.title}</h2>
              <p className="about-das-playbookDesc">{aboutDAS.playbook.description}</p>
            </div>
            <div className="about-das-grid">
              {aboutDAS.playbook.items.map((item, i) => {
                const Icon = getIcon(item.icon);
                return (
                  <a key={i} href={item.to} className={`about-das-card tone-${item.tone}`}>
                    <div className="about-das-cardBody">
                      <div className="about-das-cardHeader">
                        <span className="about-das-icon" aria-hidden="true">
                          <Icon className="about-das-iconSvg" size={20} />
                        </span>
                        <h3 className="about-das-cardTitle">{item.title}</h3>
                      </div>
                      <p className="about-das-cardDesc">{item.description}</p>
                    </div>
                    <div className="about-das-cardFooter">
                      <div className="about-das-cta">
                        {item.cta} <ArrowRight className="about-das-ctaIcon" size={16} />
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        )}
      </section>
    </>
  );
}
